import React, { useContext, useMemo, useState } from "react"
import ReactPlayer from "react-player"
import { Document, Page, pdfjs } from "react-pdf"
import "react-pdf/dist/esm/Page/TextLayer.css"
import "react-pdf/dist/esm/Page/AnnotationLayer.css"
import UserContext from "../UserContext"

export default function AdPlayerTotem({ ad, showDownload = true }) {
  // State
  const userContext = useContext(UserContext)
  const [paysage, setPaysage] = useState(false)
  const [playing, setPlaying] = useState(false)

  // Comportements
  useMemo(() => {
    setPaysage(ad.landscape)
  }, [ad])

  useMemo(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`
  }, [])

  const [width, height] = useMemo(() => {
    if (paysage) return [320, 180]
    else return [180, 320]
  }, [paysage])

  const style = useMemo(() => {
    if (paysage) return { width: "520px", height: "380px", backgroundImage: `url("/dist/img/Totem-paysage.png")` }
    else return { width: "380px", height: "520px", backgroundImage: `url("/dist/img/Totem-portrait.png")` }
  }, [paysage])

  const url = useMemo(() => {
    const adType = ["video", "image", "pdf"][ad.adTypeId - 1]
    return process.env.REACT_APP_API_HOST + `${userContext.role.id < 3 ? "/admin" : ""}/` + adType + "/" + ad.id
  }, [ad, userContext])

  // Rendu
  return (
    <div className="d-flex flex-column justify-content-center align-items-center" style={{ marginTop: "-50px" }}>
      <div className="d-flex flex-row justify-content-center align-items-center" style={style}>
        {ad.adTypeId === 1 && ( // VIDEO
          <ReactPlayer
            url={url}
            controls={false}
            playing={playing}
            loop={true}
            width={`${width}px`}
            height={`${height}px`}
            onReady={() => setPlaying(true)}
          />
        )}
        {ad.adTypeId === 2 && ( // IMAGE
          <img src={url} width={`${width}px`} height={`${height}px`} alt="Prévisualisation" />
        )}
        {ad.adTypeId === 3 && ( // PDF
          <Document
            file={{
              url: url,
              withCredentials: true,
            }}
          >
            <Page pageNumber={1} width={width} height={height} />
          </Document>
        )}
      </div>
      <div>
        {ad.adTypeId === 1 &&
          (playing ? (
            <button className="btn btn-app" onClick={() => setPlaying(false)}>
              <i className="fas fa-pause"></i> Pause
            </button>
          ) : (
            <button className="btn btn-app" onClick={() => setPlaying(true)}>
              <i className="fas fa-play"></i> Jouer
            </button>
          ))}
        {paysage ? (
          <button className="btn btn-app" onClick={() => setPaysage(false)}>
            <i className="fas fa-arrows-alt-v"></i> Portrait
          </button>
        ) : (
          <button className="btn btn-app" onClick={() => setPaysage(true)}>
            <i className="fas fa-arrows-alt-h"></i> Paysage
          </button>
        )}
        {showDownload && (
          <button
            className="btn btn-app"
            onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
            title="Télécharger la ressource"
          >
            <i className="fas fa-download"></i> Télécharger
          </button>
        )}
      </div>
    </div>
  )
}
